import React from 'react';
import SaveIcon from '@mui/icons-material/Save';
import LoadingButton from '@mui/lab/LoadingButton';
import { reportServiceClient } from 'src/utils/graph-clients';
import {
  useItemStatsExportLazyQuery,
  ExportType,
  ItemStatsExportQueryVariables,
  ItemStatsSortOption,
  SortOrder,
  OrderStatsExportQueryVariables,
  OrderStatsSortOption,
  useOrderStatsExportLazyQuery,
} from 'src/graphql/report-service/generated/operations';
import { IDatePeriod } from '../period-selector';

const ReportExporter = function ({
  mode,
  period,
  sortBy,
  sortDirection,
}: {
  mode: 'items' | 'orders';
  period: IDatePeriod | undefined;
  sortBy: ItemStatsSortOption | OrderStatsSortOption;
  sortDirection: SortOrder;
}) {
  const [queryForItemStats, { loading: itemsLoading }] = useItemStatsExportLazyQuery({
    client: reportServiceClient,
  });
  const [queryForOrderStats, { loading: ordersLoading }] = useOrderStatsExportLazyQuery({
    client: reportServiceClient,
  });
  const loading = itemsLoading || ordersLoading;

  const saveBase64CSV = (csv: string, fileName: string) => {
    const linkSource = `data:text/csv;base64,${csv}`;
    const downloadLink = document.createElement('a');

    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
    downloadLink.remove();
  };

  const performExport = async () => {
    const start = period.dates.start.format('YYYY-MM-DD');
    const end = period.dates.end.format('YYYY-MM-DD');
    let result: string;
    let fileName: string;

    if (mode === 'items') {
      fileName = `Paidit_artikelexport_${start}-${end}.csv`;
      const variables: ItemStatsExportQueryVariables = {
        exportType: ExportType.Csv,
        startDate: period?.dates?.start,
        endDate: period?.dates?.end,
        sortBy: sortBy as ItemStatsSortOption,
        sortDirection,
      };
      const response = await queryForItemStats({ variables });
      result = response.data.exportItems;
    } else {
      fileName = `Paidit_orderexport_${start}-${end}.csv`;
      const variables: OrderStatsExportQueryVariables = {
        exportType: ExportType.Csv,
        startDate: period?.dates?.start,
        endDate: period?.dates?.end,
        sortBy: sortBy as OrderStatsSortOption,
        sortDirection,
      };
      const response = await queryForOrderStats({ variables });
      result = response.data.exportOrders;
    }

    saveBase64CSV(result, fileName);
  };

  return (
    <LoadingButton
      data-test-id="export-to-file"
      disabled={!period}
      variant="contained"
      startIcon={<SaveIcon />}
      onClick={performExport}
      loadingPosition="start"
      loading={loading}
    >
      Ladda ner CSV
    </LoadingButton>
  );
};

export default ReportExporter;
